import React from "react";
import { Calendar } from "lucide-react";
import { motion } from "framer-motion";

const DEMO_BOOKING_URL =
  "https://bookings.cloud.microsoft/book/NotationAI@fownd.org/?ismsaljsauthenabled";

const StickyContact = () => {
  return (
    <motion.a
      href={DEMO_BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 280, damping: 28, delay: 0.45 }}
      aria-label="Book a demo"
      className="group fixed top-4 right-4 z-40 inline-flex h-11 items-center gap-0 overflow-hidden rounded-full border border-white/30 bg-[rgba(67,156,203,0.42)] pl-1.5 pr-4 text-white shadow-[0_10px_32px_rgba(67,156,203,0.28)] backdrop-blur-xl transition-[border-color,background-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:border-white/45 hover:bg-[rgba(67,156,203,0.58)] hover:shadow-[0_16px_40px_rgba(67,156,203,0.38)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#57AAD9]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent md:top-auto md:bottom-6 md:right-6"
      style={{
        WebkitBackdropFilter: "blur(18px) saturate(160%)",
        backdropFilter: "blur(18px) saturate(160%)",
      }}
    >
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/20 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] transition-transform duration-300 group-hover:scale-105 group-hover:bg-white/28">
        <Calendar className="h-3.5 w-3.5 text-white" strokeWidth={2.25} />
      </span>
      <span className="ml-2.5 font-productSans text-sm font-medium tracking-tight">
        Book a Demo
      </span>
    </motion.a>
  );
};

export default StickyContact;
